import { useState } from "react";

import card_front from "../../../assets/images/ani/8_March_MemoryGame/8-March-CardFront.png"
import card_back from "../../../assets/images/ani/8_March_MemoryGame/8-March-CardBack.png"

export default function FlipGreetingCard() {

  const [flip, setFlip] = useState(false);

  return (
    <div className="card-container">

      <div className="card-wrapper">
        <div className={`greeting-card ${flip ? "flip" : ""}`}>

          <div className="greeting-card-front">
            <img src={card_front} alt="8 March Card Front" />
          </div>

          <div className="greeting-card-back">
            <img src={card_back} alt="8 March Card Back" />
          </div>

        </div>
      </div>

      <button 
        className="button"
        onClick={() => setFlip(!flip)}
      >
        {flip ? "Затвори картичката" : "Прочети картичката"}
      </button>

    </div>
  );

}